import { useContext, useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { HiOutlineBan } from "react-icons/hi";
import { formatDateTime } from "utils/timeFunctions";
import { ChatContext } from "context/ChatContext";
import { IUnreadChat } from "hooks/useUserChatWebSocket";
import { useSelector } from "react-redux";
import AllChatAvatar from "./AllChatAvatar";

function ChatUser({ chatData, setSelectedChat, popUp, setChatIsOpen }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const { unreadChats, setUnreadChats } = useContext(ChatContext);
  const [recieverName, setRecieverName] = useState("Unknown User");
  const [userData, setUserData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const handleClick = () => {
    setSelectedChat(chatData);

    setUnreadChats((prevChats: IUnreadChat[]) => {
      return prevChats.filter((chat: IUnreadChat) => {
        return chat.chatId != chatData.id;
      });
    });

    if (setChatIsOpen) {
      setChatIsOpen(true);
    }
  };

  useEffect(() => {
    const chat: IUnreadChat = unreadChats.find(
      (chat: IUnreadChat) =>
        chat.chatId == chatData?.id &&
        chatData.status !== "rejected" &&
        chatData.block_status !== "blocked"
    );

    setTimeout(() => {
      setUnreadCount(chat ? chat.count : 0);
    }, 200);
  }, [chatData?.id, unreadChats]);

  useEffect(() => {
    if (chatData.receiver) {
      setUserData(chatData.receiver);
      setRecieverName(getStringAccordingToLength(chatData.receiver?.name, 20));
    }
  }, [chatData]);

  const getStringAccordingToLength = (str: string, length: number) => {
    if (str?.length > length) {
      return `${str?.slice(0, length)}...`;
    } else {
      return str;
    }
  };

  const hasUnread = unreadCount > 0;

  return (
    <div
      className="flex cursor-pointer items-center gap-3 rounded-xl border-b border-solid border-[var(--chat-border)] px-3 py-3 transition-colors hover:border-transparent hover:bg-white/[0.05]"
      onClick={popUp !== true ? handleClick : undefined}
    >
      <div className={`shrink-0 ${popUp === true ? "w-12" : "w-14"}`}>
        <AllChatAvatar chatData={chatData} popUp={popUp} />
      </div>
      <div className="min-w-0 w-full">
        <div className="mb-1 flex items-center justify-between gap-2">
          <p
            className={`flex min-w-0 items-center truncate text-base ${
              hasUnread ? "font-semibold text-white" : "text-white/90"
            }`}
            data-tooltip-id={`chat-username`}
          >
            <span className="truncate">{!isLoading && recieverName}</span>
            {chatData?.chat_name.split("-")[0] != loggedInUser?.id &&
            chatData?.status === "rejected" ? (
              <HiOutlineBan className="ml-2 shrink-0 text-red-700" />
            ) : (
              <></>
            )}
          </p>
          {chatData?.receiver && chatData.receiver?.name?.length > 20 && (
            <div className="text-sm">
              <ReactTooltip
                id={`chat-username`}
                place="top"
                content={chatData.name}
              />
            </div>
          )}
          {popUp !== true && (
            <p className="shrink-0 text-right text-xs text-[var(--clr-grey-special)]">
              {formatDateTime(chatData?.latest_message?.updated_at)}
            </p>
          )}
        </div>
        <div className="flex w-full items-center justify-between gap-2">
          <p
            className={`min-w-0 truncate text-sm ${
              hasUnread ? "text-white/80" : "text-[var(--Color7B9DB4)]"
            }`}
          >
            {!isLoading && (
              <>
                {chatData?.latest_message
                  ? getStringAccordingToLength(
                      chatData?.latest_message?.content,
                      20
                    )
                  : `No messages`}
              </>
            )}
          </p>
          {hasUnread && (
            <span className="flex h-5 min-w-[20px] shrink-0 items-center justify-center rounded-full bg-[var(--red,#F50537)] px-1.5 text-[11px] font-semibold text-white">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatUser;